import { DatasetSchema, type ExoticType } from "@sins2-atlas/game-data";
import rawDataset from "@sins2-atlas/game-data/dataset";

// Parse the bundled artifact once at startup: the UI must never trust a dataset the schema
// hasn't accepted, and the cost is microseconds on a build-time-sized JSON.
export const dataset = DatasetSchema.parse(rawDataset);

/** The five exotics by internal id — the join that turns dataset type ids into the game's
 * own names (Tauranite, Indurium, …) and icons. The schema guarantees all five exist. */
export const exoticsById = new Map(dataset.exotics.map((exotic) => [exotic.id, exotic]));

/** Roster units by stable game id — the join the entity page, the comparison view, and
 * the compare tray all resolve URL ids through. */
export const unitsById = new Map(dataset.units.map((unit) => [unit.id, unit]));

/** Whether the damage-formula gate is still open, read from the dataset's own cell states
 * so the flip stays a pure data change: regeneration deletes the gate-status sentences
 * with no code edit (Issue 09). */
export const EHP_GATED = dataset.units.some((unit) => unit.ehp.state === "formula_unverified");

/** Ship items by stable game id — the join the entity page's shop listing resolves
 * unit.items refs through (Issue 14). */
export const itemsById = new Map(dataset.items.map((item) => [item.id, item]));

export function exoticName(id: ExoticType): string {
  return exoticsById.get(id)?.name ?? id;
}

/** "1 Andvar, 2 Quarnium" — a price's exotic half, by the game's own exotic names. Empty for
 * no exotics. Four surfaces print exactly this list (review 2026-09-08). */
export function exoticCountsText(
  exotics: readonly { count: number; exoticType: ExoticType }[],
): string {
  return exotics.map((exotic) => `${exotic.count} ${exoticName(exotic.exoticType)}`).join(", ");
}
